import React, { useState, useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from "react-redux";
// import Fade from 'react-reveal/Fade'
import FormAction from './formAction'

function Demographics (props){
  const INITIAL_RACE_ETHNICITY = [0,0,0,0,0,0,0,0];
  const [state, setState] = useState({
    formData: {
      percent_completed: 30,
      gender_id: '',
      race_ethnicity: [...INITIAL_RACE_ETHNICITY],
    },
    gender_idValid: '',
    isFormDataValid: false
  })

  const numberInputs = {}
  const stepFields = ['gender_id', 'race_ethnicity'];

  const { savedSteps, selectedProgramId, selectedProgramLabel } = useSelector((state) => ({
    savedSteps: state.applicationReducer.savedSteps,
    selectedProgramId: state.applicationReducer.selectedProgramId,
    selectedProgramLabel: state.applicationReducer.selectedProgramLabel
  }), shallowEqual);

  useEffect(()=>{
    window.scrollTo(0, 0)
  },[])

  useEffect(()=>{
    populateForm();
  },[savedSteps.demographics])

  useEffect(()=>{
    validateForm();
  },[state])

  function populateForm(){
    const demographicsData = savedSteps.demographics;
    if (!!savedSteps.demographics && Object.keys(demographicsData).length > 0) {
      let raceEthnicityArr = demographicsData?.race_ethnicity?.toString()?.split(',');
      updateForm('gender_id', demographicsData.gender_id)
      raceEthnicityArr.length && updateForm('race_ethnicity', raceEthnicityArr)
    }
  }

  const updateForm = (field, value, key = null) => {

    let temp = state.formData
    switch(field) {
      case 'race_ethnicity':
        let newArr = [...INITIAL_RACE_ETHNICITY];
        if(key == null) temp[field] = value;
        else {
          newArr[key] = value;
          temp[field] = newArr;
        }
        break;
      default: temp[field] = value;
        break;
    }
    setState(prevState => ({ ...prevState, formData: temp }));
    _validate(field)
  }
  const _validate = (field) => {
    let regex, valid;
    let value = state.formData[field];
    switch(field){
      case 'race_ethnicity':
        valid = value.some((re) => re === 1);
        break;
      case 'gender_id':
        regex = /^.{1,}/;
        valid = regex.test(value)
        break;
    }
    setState(prevState => ({ ...prevState, [field+"Valid"]: valid }));
  }

  const validateForm = () => {
    let formData = state
    let form = !!formData.gender_idValid
    if (state.isFormDataValid != form) {
      setState(prevState => ({ ...prevState, isFormDataValid: form }));
    }
  }

  const toggleRaceEthnicityElement = (key) => {
    let newState = state.formData['race_ethnicity'][key] === 1 ? 0 : 1;
    updateForm('race_ethnicity', newState, key);
  }

  return(
    <>
      	<div className="app-form-container demographic residency">

      		<div className="main-heading bayan-main-heading">
            {selectedProgramLabel}
          </div>
          <div className="sub-heading app-info">
            Demographics
          </div>
          <div className="form-content">
            <div className="input-group">
              <div className="field-label">Gender</div>
              <select placeholder="Select one" value={state.formData.gender_id} onChange={(e)=>{updateForm('gender_id', e.target.value)}}>
              <option value=''>Select One</option>
                <option value='1' select={state.formData.gender_id == 1 ? 'selected': ''}>Male</option>
                <option value='2' select={state.formData.gender_id == 2 ? 'selected': ''}>Female</option>
                <option value='4' select={state.formData.gender_id == 4 ? 'selected': ''}>Non-Conforming</option>
                <option value='3' select={state.formData.gender_id == 3 ? 'selected': ''}>Decline to state</option>
              </select>
            </div>

            <div className="input-group">
              <div className="field-label">Self-Identified Race/Ethnicity?</div>
              <div className="inline-radio">
                <div className={`radio-options`}>
                  <div className={`radio-button ${state.formData['race_ethnicity'][0] == 1 ? 'selected':''}`} onClick={()=>{toggleRaceEthnicityElement(0)}}></div>
                  <div className={`radio-label`} onClick={()=>{toggleRaceEthnicityElement(0)}}>White/Non-Hispanic</div>
                </div>
              </div>
              <div className="inline-radio">
                <div className={`radio-options`}>
                  <div className={`radio-button ${state.formData['race_ethnicity'][1] == 1 ? 'selected':''}`} onClick={()=>{toggleRaceEthnicityElement(1)}}></div>
                  <div className={`radio-label`} onClick={()=>{toggleRaceEthnicityElement(1)}}>Hispanic/Latinx/Spanish Origin</div>
                </div>
              </div>
              <div className="inline-radio">
                <div className={`radio-options`}>
                  <div className={`radio-button ${state.formData['race_ethnicity'][2] == 1 ? 'selected':''}`} onClick={()=>{toggleRaceEthnicityElement(2)}}></div>
                  <div className={`radio-label`} onClick={()=>{toggleRaceEthnicityElement(2)}}>Black or African American</div>
                </div>
              </div>
              <div className="inline-radio">
                <div className={`radio-options`}>
                  <div className={`radio-button ${state.formData['race_ethnicity'][3] == 1 ? 'selected':''}`} onClick={()=>{toggleRaceEthnicityElement(3)}}></div>
                  <div className={`radio-label`} onClick={()=>{toggleRaceEthnicityElement(3)}}>Asian/Pacific Islander</div>
                </div>
              </div>
              <div className="inline-radio">
                <div className={`radio-options`}>
                  <div className={`radio-button ${state.formData['race_ethnicity'][4] == 1 ? 'selected':''}`} onClick={()=>{toggleRaceEthnicityElement(4)}}></div>
                  <div className={`radio-label`} onClick={()=>{toggleRaceEthnicityElement(4)}}>Middle Eastern/North African Descent</div>
                </div>
              </div>
              <div className="inline-radio">
                <div className={`radio-options`}>
                  <div className={`radio-button ${state.formData['race_ethnicity'][8] == 1 ? 'selected':''}`} onClick={()=>{toggleRaceEthnicityElement(8)}}></div>
                  <div className={`radio-label`} onClick={()=>{toggleRaceEthnicityElement(8)}}>Native American/Alaskan</div>
                </div>
              </div>
              {/* <div className="inline-radio">
                <div className={`radio-options`}>
                  <div className={`radio-button ${state.formData['race_ethnicity'][5] == 1 ? 'selected':''}`} onClick={()=>{toggleRaceEthnicityElement(5)}}></div>
                  <div className={`radio-label`} onClick={()=>{toggleRaceEthnicityElement(5)}}>Non-Resident Alien</div>
                </div>
              </div> */}
              <div className="inline-radio">
                <div className={`radio-options`}>
                  <div className={`radio-button ${state.formData['race_ethnicity'][6] == 1 ? 'selected':''}`} onClick={()=>{toggleRaceEthnicityElement(6)}}></div>
                  <div className={`radio-label`} onClick={()=>{toggleRaceEthnicityElement(6)}}>Undisclosed</div>
                </div>
              </div>
              <div className="inline-radio">
                <div className={`radio-options`}>
                  <div className={`radio-button ${state.formData['race_ethnicity'][7] == 1 ? 'selected':''}`} onClick={()=>{toggleRaceEthnicityElement(7)}}></div>
                  <div className={`radio-label`} onClick={()=>{toggleRaceEthnicityElement(7)}}>Other</div>
                </div>
              </div>
              {/* {!s.genderValid && <div className="field-error">Must select an option.</div>} */}
            </div>

          </div>

          <FormAction
            isFormDataValid={state.isFormDataValid}
            formData={state.formData}
            formStep={'demographics'}
            backStep={'residency'}
            nextStep={'academicInfo'}
          />
      	</div>
    </>
    );
  }


// const mapStateToProps = state => ({
//   savedSteps: state.application.savedSteps,
//   reqForm: state.user.data,
// })

export default Demographics;
